
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/es-mx/opendock",
      function () {
        return require("private-next-pages/es-mx/opendock/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/es-mx/opendock"])
      });
    }
  